import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import UserLogin from "./UserLogin";
import StudentLogin from "./StudentLogin";
import "./Login.css";

function Login({ onClose, onShowSignup }) {
  const [loginUserType, setLoginUserType] = useState("client");

  useEffect(() => {
    const oauthUserType = sessionStorage.getItem("oauthAuthUserType");
    if (oauthUserType === "client" || oauthUserType === "student") {
      setLoginUserType(oauthUserType);
      sessionStorage.removeItem("oauthAuthUserType");
    }
  }, []);

  return (
    <div className="main-login-scope">
      <div className="main-login-modal-overlay" onClick={onClose}>
        <div
          className="main-login-modal-box"
          onClick={(e) => e.stopPropagation()}
        >
          <button className="main-login-modal-close" onClick={onClose}>
            <FaTimes />
          </button>

          <div className="main-login-modal-split">
            {/* LEFT */}
            <div className="main-login-left-panel">
              <div className="main-login-type-toggle">
                <div className={`main-toggle-slider ${loginUserType}`} />

                <button
                  className={loginUserType === "client" ? "active" : ""}
                  onClick={() => setLoginUserType("client")}
                >
                  Client
                </button>

                <button
                  className={loginUserType === "student" ? "active" : ""}
                  onClick={() => setLoginUserType("student")}
                >
                  Student
                </button>
              </div>

              {loginUserType === "client" ? (
                <UserLogin onClose={onClose} onShowSignup={onShowSignup} />
              ) : (
                <StudentLogin onClose={onClose} onShowSignup={onShowSignup} />
              )}
            </div>

            {/* RIGHT — branded panel */}
            <div className="main-login-right-panel">
              <div className="auth-brand-overlay">
                <div className="auth-brand-orb">🚀</div>
                <h2 className="auth-brand-title">Welcome back to<br />MarsMate <span className="auth-brand-ai">AI</span></h2>
                <p className="auth-brand-sub">
                  Validate ideas, map your strategy, and generate investor-ready
                  reports — all powered by AI.
                </p>
                <ul className="auth-brand-features">
                  <li><span className="auth-feature-check">✓</span> AI-powered idea validation</li>
                  <li><span className="auth-feature-check">✓</span> Strategic mind mapping</li>
                  <li><span className="auth-feature-check">✓</span> Investor-ready reports</li>
                  <li><span className="auth-feature-check">✓</span> MarsMart e-commerce suite</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
